import { __spreadArray } from "tslib";
import { chain } from 'lodash';
import { SectionType } from '../../../types';
import * as defaults from '../../defaults';
import { injectMissingPropsIntoHtml } from '../../inject-missing-props-into-html';
export var getAllTextRegions = function (composerData, sections, experiments) { return __spreadArray(__spreadArray([], getHtmlFromTextRegions(composerData, experiments)), getHtmlFromTextSubRegionsInMix(composerData, sections, experiments)); };
function getHtmlFromTextRegions(_a, experiments) {
    var regions = _a.regions, styles = _a.styles;
    return regions
        .filter(function (_a) {
        var type = _a.type;
        return type === SectionType.text;
    })
        .map(function (_a) {
        var data = _a.data, fixed = _a.fixed;
        var cssClass = fixed ? 'so-global-title' : 'so-global-p1';
        var textStyle = styles.css[cssClass];
        var props = {
            lineHeight: textStyle.originalLineHeight || defaults.defaultLineHeight,
            fontSize: textStyle.fontSize || defaults.defaultTextSize,
        };
        var html = "<div class=" + cssClass + ">" + data.html + "</div>";
        return injectMissingPropsIntoHtml(html, props, { styles: styles }, styles.css, experiments);
    });
}
function getHtmlFromTextSubRegionsInMix(_a, sections, experiments) {
    var styles = _a.styles;
    return chain(sections)
        .filter(function (_a) {
        var type = _a.type;
        return type === SectionType.mix;
    })
        .map(function (section) { return section.regions; })
        .flatten()
        .filter(function (_a) {
        var type = _a.type;
        return type === SectionType.text;
    })
        .map(function (_a) {
        var html = _a.html;
        var cssClass = 'so-global-p1';
        var textStyle = styles.css[cssClass];
        var props = {
            lineHeight: textStyle.originalLineHeight || defaults.defaultLineHeight,
            fontSize: textStyle.fontSize || defaults.defaultTextSize,
        };
        return injectMissingPropsIntoHtml("<div class=" + cssClass + ">" + html + "</div>", props, { styles: styles }, styles.css, experiments);
    })
        .value();
}
//# sourceMappingURL=get-all-text-regions.js.map